module.exports = __webpack_public_path__ + "static/media/ambasada.7dbadebb.svg";